import { FC } from 'react';
import { cn } from '@new/lib';
import { Checkbox } from '@new/common/ui/Checkbox/Checkbox';

interface VideoVerificationStepProps {
  value: boolean;
  onChange: (checked: boolean) => void;
}

export const VideoVerificationStep: FC<VideoVerificationStepProps> = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-10 items-center w-full">
      <iframe
        title="Onboarding video"
        src="https://www.youtube.com/embed/mONwcZL0N4g"
        allowFullScreen
        className="rounded-md w-full h-full md:h-[364px]"
      />
      <div className="w-full">
        <div
          className={cn(
            'box-border flex justify-between items-center py-5 lg:py-7 px-5 lg:pl-8 lg:pr-6 bg-(--neutral-white-NW800)! rounded-md border-2 cursor-pointer transition-colors',
            value ? 'border-(--neutral-black-NB1000)' : 'border-transparent'
          )}
        >
          <p className="text-start [font-family:var(--font-montserrat)]! text-[10px] lg:[font-size:var(--fs-p3)]! leading-(--lh-p)! font-medium! m-0! text-(--neutral-black-NB1000)!">
            Did you watch the complete video
          </p>
          <Checkbox value={value} onChange={onChange} variant="simple" />
        </div>
      </div>
    </div>
  );
};
